<template>
  <div class="container">
    <div class="header-btns">
      <div class="btn">
        <add-dialog
          @change="
            () => {
              handleSearch();
            }
          "
        >
          <el-button class="mwow-button-filled success">添加学员</el-button>
        </add-dialog>
      </div>
      <div class="btn">
        <muti-edit-dialog
          :ori="multipleSelection"
          @change="
            () => {
              handleRefresh();
            }
          "
        >
          <el-button
            :class="`mwow-button-filled ${
              multipleSelection.length === 0 ? 'disable' : 'primary'
            }`"
            >批量分配</el-button
          >
        </muti-edit-dialog>
      </div>
      <div class="btn">
        <upload-table-dialog
          @change="
            () => {
              handleRefresh();
            }
          "
        >
          <el-button class="mwow-button-filled warning">导入</el-button>
        </upload-table-dialog>
      </div>
      <div
        class="mwow-button-filled primary"
        @click="clickexport"
        v-debounce="5000"
      >
        导出
      </div>
    </div>
    <div class="top-search-wrap">
      <div class="mwow-form">
        <el-radio-group
          v-model="topSearchInfo.distribute_status"
          @change="
            () => {
              topSearchInfo.quick = 'all';
              handleSearch();
            }
          "
        >
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button label="have_follow_staff"
            >有课程顾问</el-radio-button
          >
          <el-radio-button label="not_follow_staff">无课程顾问</el-radio-button>
        </el-radio-group>
      </div>
      <div class="quick-wrap">
        <span class="title">快捷筛选:</span>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'all' }"
          @click="handleQuickSearch('all')"
          v-debounce="1000"
        >
          全部
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'not_potential' }"
          @click="handleQuickSearch('not_potential')"
          v-if="topSearchInfo.distribute_status !== 'have_follow_staff'"
          v-debounce="1000"
        >
          无进入公海池
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'join_potential' }"
          @click="handleQuickSearch('join_potential')"
          v-if="topSearchInfo.distribute_status !== 'have_follow_staff'"
          v-debounce="1000"
        >
          已进入公海池
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'wait_for_follow_today' }"
          @click="handleQuickSearch('wait_for_follow_today')"
          v-if="topSearchInfo.distribute_status !== 'not_follow_staff'"
          v-debounce="1000"
        >
          今日待跟进
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'wait_for_follow_week' }"
          @click="handleQuickSearch('wait_for_follow_week')"
          v-if="topSearchInfo.distribute_status !== 'not_follow_staff'"
          v-debounce="1000"
        >
          本周待跟进
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'never_before_follow' }"
          @click="handleQuickSearch('never_before_follow')"
          v-debounce="1000"
        >
          从未跟进过的
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'follow_complete_today' }"
          @click="handleQuickSearch('follow_complete_today')"
          v-if="topSearchInfo.distribute_status !== 'not_follow_staff'"
          v-debounce="1000"
        >
          今日已跟进
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'follow_complete_week' }"
          @click="handleQuickSearch('follow_complete_week')"
          v-debounce="1000"
        >
          本周已跟进
        </div>
        <div
          class="mwow-button"
          :class="{
            success: topSearchInfo.quick === 'experience_complete_week',
          }"
          @click="handleQuickSearch('experience_complete_week')"
          v-debounce="1000"
        >
          本周已体验
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'new_create_today' }"
          @click="handleQuickSearch('new_create_today')"
          v-debounce="1000"
        >
          今日新增
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'new_create_week' }"
          @click="handleQuickSearch('new_create_week')"
          v-debounce="1000"
        >
          本周新增
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'new_create_month' }"
          @click="handleQuickSearch('new_create_month')"
          v-debounce="1000"
        >
          本月新增
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'potential_claim_today' }"
          @click="handleQuickSearch('potential_claim_today')"
          v-if="topSearchInfo.distribute_status !== 'not_follow_staff'"
          v-debounce="1000"
        >
          今日公海主动认领
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'potential_claim_week' }"
          @click="handleQuickSearch('potential_claim_week')"
          v-if="topSearchInfo.distribute_status !== 'not_follow_staff'"
          v-debounce="1000"
        >
          本周公海主动认领
        </div>
        <div
          class="mwow-button"
          :class="{ success: topSearchInfo.quick === 'potential_claim_month' }"
          @click="handleQuickSearch('potential_claim_month')"
          v-if="topSearchInfo.distribute_status !== 'not_follow_staff'"
          v-debounce="1000"
        >
          本月公海主动认领
        </div>
      </div>
    </div>
    <common-search-form-wrapper :reset="resetSearch">
      <el-form
        size="mini"
        :model="searchInfo"
        label-position="right"
        label-width="66px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜索:" prop="key_word">
              <el-input
                v-model="searchInfo.key_word"
                placeholder="学员姓名/手机号"
                @change="handleSearch"
                clearable
                prefix-icon="el-icon-search"
                maxlength="99"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别:" prop="sex" label-width="90px">
              <el-select
                v-model="searchInfo.sex"
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option label="未知" :value="0"></el-option>
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄分布:">
              <el-select
                v-model="searchInfo.age_stage"
                placeholder="请选择"
                clearable
                @change="handleSearch"
              >
                <el-option label="暂无年龄" :value="8"></el-option>
                <el-option label="X ≤ 3" :value="1"></el-option>
                <el-option label="3 < X ≤ 6" :value="2"></el-option>
                <el-option label="6 < X ≤ 9" :value="3"></el-option>
                <el-option label="9 < X ≤ 12" :value="4"></el-option>
                <el-option label="12 < X ≤ 15" :value="5"></el-option>
                <el-option label="15 < X ≤ 18" :value="6"></el-option>
                <el-option label="18 < X" :value="7"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="出现方式:" prop="appear_id">
              <el-select
                v-model.number="searchInfo.appear_id"
                filterable
                clearable
                placeholder="请选择"
                @change="handleSearch('appear')"
              >
                <el-option
                  v-for="item in studentAppearLabelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="来源渠道:"
              prop="source_type"
              label-width="90px"
            >
              <el-select
                v-model="searchInfo.source_type"
                placeholder="请选择"
                @change="handleSearch"
                clearable
                @focus="
                  () => {
                    if (!searchInfo.appear_id) {
                      $message({
                        message: '请选择出现方式',
                        type: 'warning',
                      });
                    }
                  }
                "
              >
                <el-option
                  v-for="item in sourceList"
                  :key="item.source_id"
                  :label="item.name"
                  :value="item.source_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="意向科目:" prop="subject_ids">
              <el-select
                v-model="searchInfo.subject_ids"
                placeholder="请选择"
                clearable
                @change="handleSearch"
                @focus="getSubjectList"
                multiple
              >
                <el-option
                  v-for="item in subjectsList"
                  :key="item.subject_id"
                  :label="item.subject_title"
                  :value="item.subject_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="分配次数:" prop="allocate_num">
              <div class="allocate-wrap">
                <el-input
                  v-model="searchInfo.allocate_num_start"
                  type="number"
                  placeholder="最低次数"
                  @change="
                    (v) => {
                      let res = '';
                      if (v !== '') {
                        res = Number(v);
                        if (
                          searchInfo.allocate_num_end !== '' &&
                          res > Number(searchInfo.allocate_num_end)
                        ) {
                          $message({
                            type: 'warning',
                            message: '最低次数不可高于最高次数',
                          });
                          res = '';
                        }
                        if (res < 0) {
                          $message({
                            type: 'warning',
                            message: '最低次数不可小于0',
                          });
                          res = '';
                        }
                        if (res > 99999) {
                          $message({
                            type: 'warning',
                            message: '最低次数数值过大',
                          });
                          res = '';
                        }
                      }
                      searchInfo.allocate_num_start =
                        res !== '' ? Math.floor(res) : '';
                      handleSearch();
                    }
                  "
                ></el-input>
                <span>至</span>
                <el-input
                  v-model="searchInfo.allocate_num_end"
                  type="number"
                  placeholder="最高次数"
                  @change="
                    (v) => {
                      let res = '';
                      if (v !== '') {
                        res = Number(v);
                        if (
                          searchInfo.allocate_num_start !== '' &&
                          res < Number(searchInfo.allocate_num_start)
                        ) {
                          $message({
                            type: 'warning',
                            message: '最高次数不可低于最高次数',
                          });
                          res = '';
                        }
                        if (res < 0) {
                          $message({
                            type: 'warning',
                            message: '最高次数不可小于0',
                          });
                          res = '';
                        }
                        if (res > 99999) {
                          $message({
                            type: 'warning',
                            message: '最高次数数值过大',
                          });
                          res = '';
                        }
                      }
                      searchInfo.allocate_num_end =
                        res !== '' ? Math.floor(res) : '';
                      handleSearch();
                    }
                  "
                >
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="最近跟进时间:"
              prop="follow_time"
              label-width="90px"
            >
              <!-- <el-date-picker
                v-model="searchInfo.follow_time"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.follow_time"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程顾问:" prop="follow_staff_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.follow_staff_id"
                :defaultSelected.sync="searchInfo.follow_staff_list"
                :jobIds="[3]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="跟进阶段:" prop="stage">
              <el-select
                v-model="searchInfo.stage"
                placeholder="请选择"
                @focus="getFollowStage"
                @change="handleSearch"
                clearable
              >
                <el-option
                  v-for="item in followStageList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="跟进状态:"
              prop="follow_status"
              label-width="90px"
            >
              <el-select
                v-model="searchInfo.follow_status"
                multiple
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户意向:" prop="intent">
              <el-select
                v-model="searchInfo.degree_of_interest"
                multiple
                filterable
                default-first-option
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option label="D" key="0" :value="0"> </el-option>
                <el-option label="C" key="1" :value="1"> </el-option>
                <el-option label="B" key="2" :value="2"> </el-option>
                <el-option label="A" key="3" :value="3"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="创建人:" prop="create_staff_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.create_staff_id"
                :defaultSelected.sync="searchInfo.create_staff_list"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="获取时间:" prop="date" label-width="90px">
              <common-date-range-selector
                v-model="searchInfo.acquisition_time"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建时间:" prop="date">
              <common-date-range-selector
                v-model="searchInfo.date"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="市场顾问:" prop="title">
              <el-select
                v-model="searchInfo.market_staff_id"
                placeholder="请输入市场顾问姓名或手机号"
                clearable
                @clear="handleSearchMarketStaff('')"
                filterable
                :filter-method="handleSearchMarketStaff"
                @visible-change="handleMarketStaffVisible"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in market_staff_list"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="推广活动:"
              prop="promotion_activities"
              label-width="90px"
            >
              <el-select
                v-model="searchInfo.activity_id"
                placeholder="请输入活动名称"
                clearable
                @focus="getActivitySelectList('')"
                filterable
                :filter-method="getActivitySelectList"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in activityTitleList"
                  :key="item.activity_id"
                  :label="item.title"
                  :value="item.activity_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注:" prop="remark">
              <el-input
                v-model="searchInfo.remark"
                placeholder="请输入备注"
                @change="handleSearch"
                clearable
                maxlength="99"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      class="mwow-table"
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      :default-sort="{ prop: 'create_time', order: 'descending' }"
      @sort-change="clickStort"
      ref="main-table"
    >
      <el-table-column
        type="selection"
        width="52"
        align="center"
      ></el-table-column>
      <el-table-column label="学员姓名" prop="name">
        <template slot-scope="scope">
          <div class="mwow-gray" v-if="scope.row.is_del === 1">
            {{ scope.row.name || "-"
            }}<span class="mwow-tag del-filled large">已删除</span>
          </div>
          <div
            v-else
            class="mwow-green"
            style="cursor: pointer"
            @click="handleFollow(scope.row.id)"
          >
            {{ scope.row.name || "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="mobile" width="145">
        <template slot-scope="scope">
          <div v-if="scope.row.mobile">
            {{ "+" + scope.row.area_code }} {{ scope.row.mobile || "-" }}
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p style="text-align: center">
                {{ `${scope.row.wechat_status === 0 ? "未" : "已"}绑定微信` }}
              </p>
              <i
                class="iconfont icon-wechat"
                slot="reference"
                :style="`margin-left:6px;font-size:15px;color:${
                  scope.row.wechat_status === 0 ? '#CCCCCC' : '#01D20B'
                }`"
              ></i>
            </el-popover>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="微信号" prop="wechat" width="125">
        <template slot-scope="scope">
          <div>{{ scope.row.wechat || "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="性别" prop="sex" width="60">
        <template slot-scope="scope">
          <span v-if="scope.row.sex === 0">未知</span>
          <span v-else-if="scope.row.sex === 1">男</span>
          <span v-else-if="scope.row.sex === 2">女</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="年龄" prop="age" width="60">
        <template slot-scope="scope">{{ scope.row.age }}</template>
      </el-table-column>
      <el-table-column
        label="分配次数"
        prop="allocate_num"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column
        label="最近分配时间"
        prop="allocate_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column
        label="最近跟进时间"
        prop="follow_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column label="出现方式" prop="appear_id">
        <template slot-scope="scope">
          {{ handleAppear(scope) }}
        </template>
      </el-table-column>
      <el-table-column label="来源渠道" prop="source_type">
        <template slot-scope="scope">
          {{ scope.row.student_source ? scope.row.student_source.name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="推广活动" prop="market_activity">
        <template slot-scope="scope">
          {{
            scope.row.market_activity ? scope.row.market_activity.title : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column label="用户意向" prop="intent">
        <template slot-scope="scope">
          {{ followLatentObj[scope.row.intent] || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="意向科目" prop="student_subject">
        <template slot-scope="scope">
          <span
            class="dot"
            v-for="item in scope.row.student_subject"
            :key="item.subject_ids"
            >{{ item.subject_title || "-" }}</span
          >
          <span
            v-if="
              !scope.row.student_subject ||
              scope.row.student_subject.length === 0
            "
            >-</span
          >
        </template>
      </el-table-column>
      <el-table-column label="市场顾问" prop="market_staff">
        <template slot-scope="scope">
          <div>
            {{ scope.row.market_staff ? scope.row.market_staff.name : "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="课程顾问" prop="follow_staff">
        <template slot-scope="scope">
          <span v-if="scope.row.follow_staff">{{
            scope.row.follow_staff.name || "-"
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="跟进状态" prop="follow_staff_id" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.follow_staff_id > 0 && scope.row.stage > 0"
            >已跟进</span
          >
          <span v-if="scope.row.follow_staff_id > 0 && scope.row.stage == 0"
            >待跟进</span
          >
          <span v-if="scope.row.follow_staff_id === 0">未分配</span>
        </template>
      </el-table-column>
      <el-table-column label="跟进阶段" prop="stage" width="80">
        <template slot-scope="scope">{{
          scope.row.follow_stage ? scope.row.follow_stage.name : "-"
        }}</template>
      </el-table-column>
      <el-table-column
        label="上次跟进时间"
        prop="format_last_follow_time"
        width="140"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column
        prop="follow_log.content"
        label="最近跟进内容"
        class-name="follow-content"
        width="270"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.follow_log != null && scope.row.follow_log.content"
          >
            <el-popover
              placement="top-start"
              title="最近跟进内容"
              width="200"
              trigger="hover"
              :content="scope.row.follow_log.content"
            >
              <span
                slot="reference"
                class="mwow-green cu-po"
                @click="followContent(scope.row.follow_log, 'look')"
              >
                {{ scope.row.follow_log.content }}
              </span>
            </el-popover>
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="下次跟进时间"
        prop="format_next_follow_time"
        width="140"
      ></el-table-column>
      <el-table-column label="创建人" prop="create_staff" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.create_staff">{{
            scope.row.create_staff.name || "-"
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="获取时间"
        prop="acquisition_time"
        sortable="custom"
        width="130"
        style="display: flex"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot="header">
          <div class="selfheader">
            <div>获取时间</div>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="133"
            >
              <p class="tipck">学员最近一次从其他状态变为意向时的时间</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="sortBox">
            {{ scope.row.acquisition_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        width="130"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot="header">
          <div class="selfheader">
            <div>创建时间</div>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="133"
            >
              <p class="tipck">首次录入系统的时间，不受回收再次转化等影响</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="sortBox">
            {{ scope.row.create_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="备注" pror="remark" width="340px">
        <template slot-scope="scope">
          <div v-if="scope.row.remark">
            <div v-if="scope.row.remark.length > 46">
              <el-popover
                placement="top"
                popper-class="followuppopover"
                trigger="hover"
              >
                <p style="width: 320px">{{ scope.row.remark }}</p>
                <p slot="reference">{{ scope.row.remark.slice(0, 46) }}...</p>
              </el-popover>
            </div>
            <div v-else>{{ scope.row.remark }}</div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="240">
        <template slot-scope="scope">
          <div class="table-btns">
            <el-button class="mwow-button primary" @click="handlePay(scope.row)"
              >缴费</el-button
            >
            <el-button
              class="mwow-button warning"
              @click="followContent(scope.row.id, 'add', scope.row)"
              >跟进</el-button
            >
            <el-button
              class="mwow-button success"
              @click="toCreateSechdule(scope.row)"
              >体验课排课</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <detailsDialog
      v-if="showDialog"
      :type="dialogType"
      :itemdata="dialogidetailsid"
      @back="dialogHide"
      :showStudentInfo="true"
      :studentInfo="studentInfo"
    />
  </div>
</template>
<script>
import { PageModule } from "@/store/module/page";
import { getLatentStudentListApi, latentListExport } from "@/api/studentManage";
import {
  getActivitySelectListApi,
  getMarketStaffListApi,
} from "@/api/marketActivity";
import eventBus from "@/utils/bus";
import detailsDialog from "../../../teachManagement/studentManage/studyDetails/detailsDialog.vue";
import { getFollowLatentApi, getFollowStageApi } from "@/api/studentFollow";
import addDialog from "./addDialog.vue";
import { subjectList } from "@/api/subject";
import mutiEditDialog from "./mutiEditDialog.vue";
import uploadTableDialog from "./uploadTableDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import { exportLoop } from "@/utils/export";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
export default {
  props: ["visible"],
  components: {
    addDialog,
    mutiEditDialog,
    uploadTableDialog,
    detailsDialog,
    commonStaffPullDown,
    commonSearchFormWrapper,
    commonDateRangeSelector,
  },
  data() {
    return {
      topSearchInfo: {
        distribute_status: "all",
        quick: "all",
      },
      searchInfo: {
        degree_of_interest: [],
        date: [],
        follow_status: [],
        follow_time: [],
        sort_type: "desc",
        sort_field: "create_time",
        market_staff_id: "",
        follow_staff_id: "",
        follow_staff_list: [],
        create_staff_id: "",
        create_staff_list: [],
        allocate_num_start: "",
        allocate_num_end: "",
      },
      studentInfo: {}, // 学生信息
      showDialog: false, //弹框开关
      dialogidetailsid: 0, //弹框id
      dialogType: "", //弹框类型
      subjectsList: [],
      sourceList: [],
      followLatent: [],
      followLatentObj: {},
      followStageList: [],
      tableData: [],
      multipleSelection: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      activityTitleList: [],
      market_staff_list: [],
      options: [
        {
          label: "已跟进",
          value: 1,
        },
        {
          label: "未分配",
          value: 2,
        },
        {
          label: "待跟进",
          value: 3,
        },
      ],
      followStatus: {
        1: "已跟进",
        2: "已跟进",
        3: "已逾期",
        4: "已取消",
      },
      studentAppearLabelList: [],
    };
  },
  created() {
    eventBus.$on("latent-list-update-latent", () => {
      const table = this.$refs["main-table"];
      table.clearSelection();
      this.handleRefresh();
    });
    if (
      PageModule.latestRoute === "studyDetails" ||
      PageModule.latestRoute === "buyCourseConfirm"
    ) {
      const cache = PageModule.pageInfo.recruitLatentList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    } else if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      const params = this.$route.params;
      if (params.start_time && params.end_time) {
        this.searchInfo.date = [params.start_time, params.end_time];
      }
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      console.log(this.visible);
      this.init();
    }
  },
  methods: {
    init() {
      getFollowLatentApi().then((res) => {
        this.followLatent = res.data.list;
        const obj = {};
        res.data.list.map((item) => {
          obj[item.key] = item.value;
        });
        this.followLatentObj = obj;
      });
      getStudentAppearListApi({
        page: 1,
        page_size: 500,
      }).then((res) => {
        this.studentAppearLabelList = res.data.list;
      });
      this.handleSearch();
    },
    getSubjectList() {
      if (this.subjectsList.length > 0) {
        return false;
      }
      subjectList({
        page: 1,
        page_size: 100,
      }).then((res) => {
        if (res.error_code === 0) {
          this.subjectsList = [...res.data.list];
        }
      });
    },
    getFollowStage() {
      if (this.followStageList.length > 0) {
        return false;
      }
      getFollowStageApi({ include_del: 1 }).then((res) => {
        this.followStageList = res.data.list;
      });
    },
    handleAppear(scope) {
      let target = this.studentAppearLabelList.find((item) => {
        return scope.row.appear_id === item.id;
      });
      if (target) {
        return target.name;
      } else {
        return "-";
      }
    },
    handleQuickSearch(type) {
      this.topSearchInfo.quick = type;
      this.handleSearch();
    },
    // 活动名称列表
    getActivitySelectList(v) {
      getActivitySelectListApi({
        page: 1,
        page_size: 100,
        title: v,
        activity_status_arr: [2, 3],
      }).then((res) => {
        if (res.error_code === 0) {
          this.activityTitleList = res.data.list;
        }
      });
    },
    // 获取市场顾问列表
    getMarketStaffList(v) {
      getMarketStaffListApi({
        page: 1,
        page_size: 100,
        keyword: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.market_staff_list = res.data.list;
        }
      });
    },
    // 模糊搜索 - 市场顾问
    handleSearchMarketStaff(v) {
      this.getMarketStaffList(v);
    },
    // 市场顾问列表下拉
    handleMarketStaffVisible(rest) {
      if (rest) {
        this.getMarketStaffList();
      }
    },
    toCreateSechdule(data) {
      PageModule.SET_PAGE_INFO({
        name: "recruitExperienceList",
        key: "selected_student",
        value: {
          avatar_url: data.avatar_url,
          is_del: data.is_del,
          mobile: data.mobile,
          name: data.name,
          org_id: data.org_id,
          sex: data.sex,
          status: data.status,
          student_id: data.student_id,
        },
      });
      this.$router.push({
        name: "experienceSechdule",
        query: {
          sid: data.student_id,
          sname: data.name,
        },
      });
    },
    resetSearch() {
      this.searchInfo = {
        degree_of_interest: [],
        date: [],
        follow_status: [],
        sort_type: this.searchInfo.sort_type,
        sort_field: this.searchInfo.sort_field,
        market_staff_id: "",
        follow_staff_id: "",
        follow_staff_list: [],
        create_staff_id: "",
        create_staff_list: [],
      };
      this.page = 1;
      this.pageSize = 10;
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
      this.savePageInfo();
    },
    followContent(data, type, info) {
      this.studentInfo = info;
      this.showDialog = true;
      this.dialogType = type;
      this.dialogidetailsid = data;
    },
    dialogHide(e) {
      this.showDialog = false;
      if (e == "add" || e == "followUp") {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      }
    },
    handleSearch(evt) {
      if (evt === "appear") {
        if (this.searchInfo.appear_id) {
          sourceTypeSelectListApi({
            appear_id: this.searchInfo.appear_id,
          }).then((res) => {
            this.sourceList = res.data.list;
          });
        } else {
          this.sourceList = [];
        }
        this.searchInfo.source_type = "";
      }
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    solveSearchParams() {
      let option = {};
      if (this.searchInfo.key_word) {
        option.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.sex !== "") {
        option.sex = this.searchInfo.sex;
      }
      if (this.searchInfo.source_type !== "") {
        option.source_type = this.searchInfo.source_type;
      }
      if (this.searchInfo.appear_id !== "") {
        option.appear_id = this.searchInfo.appear_id;
      }
      if (this.searchInfo.subject_ids !== "") {
        option.subject_ids = this.searchInfo.subject_ids;
      }
      if (this.searchInfo.follow_staff_id !== "") {
        option.follow_staff_id = this.searchInfo.follow_staff_id;
      }
      if (this.searchInfo.create_staff_id !== "") {
        option.create_staff_id = this.searchInfo.create_staff_id;
      }
      if (this.searchInfo.date && this.searchInfo.date.length === 2) {
        option.start_time =
          new Date(this.searchInfo.date[0]?.replace(/-/g, "/")).getTime() /
          1000;
        option.end_time =
          (new Date(this.searchInfo.date[1]?.replace(/-/g, "/")).getTime() +
            24 * 60 * 60 * 1000 -
            1000) /
          1000;
      }
      if (
        this.searchInfo.follow_time &&
        this.searchInfo.follow_time.length === 2
      ) {
        option.follow_start_time = this.searchInfo.follow_time[0];
        option.follow_end_time = this.searchInfo.follow_time[1];
      }
      if (this.searchInfo.allocate_num_start) {
        option.allocate_num_start = Number(this.searchInfo.allocate_num_start);
      }
      if (this.searchInfo.allocate_num_end) {
        option.allocate_num_end = Number(this.searchInfo.allocate_num_end);
      }
      if (this.searchInfo.acquisition_time) {
        option.acquisition_start_time = this.searchInfo.acquisition_time[0];
        option.acquisition_end_time = this.searchInfo.acquisition_time[1];
      }
      if (this.searchInfo.degree_of_interest.length > 0) {
        option.intent_arr = this.searchInfo.degree_of_interest;
      }
      if (this.searchInfo.follow_status.length > 0) {
        option.follow_status = this.searchInfo.follow_status;
      }
      if (this.searchInfo.stage !== "") {
        option.stage = this.searchInfo.stage;
      }
      if (
        this.searchInfo.sort_type !== "" &&
        this.searchInfo.sort_field !== ""
      ) {
        option.sort_type = this.searchInfo.sort_type;
        option.sort_field = this.searchInfo.sort_field;
      }
      if (this.searchInfo.age_stage > 0) {
        option.age_stage = this.searchInfo.age_stage;
      }
      if (this.searchInfo.market_staff_id) {
        option.market_staff_id = this.searchInfo.market_staff_id;
      }
      if (this.searchInfo.activity_id) {
        option.market_activity_id = this.searchInfo.activity_id;
      }
      if (this.searchInfo.remark) {
        option.remark = this.searchInfo.remark;
      }
      if (this.topSearchInfo.distribute_status !== "all") {
        option.follow_staff_filtering = this.topSearchInfo.distribute_status;
      }
      if (this.topSearchInfo.quick !== "all") {
        option.quick_filtering = this.topSearchInfo.quick;
      }
      return option;
    },
    clickexport() {
      let data = this.solveSearchParams();
      latentListExport(data).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        ...this.solveSearchParams(),
      };
      if (this.searchInfo.sort_type !== "") {
        option.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field !== "") {
        option.sort_field = this.searchInfo.sort_field;
      }
      getLatentStudentListApi(option).then((res) => {
        res.data.list = res.data.list || [];
        this.page = res.data.page;
        this.total = res.data.total;
        const today = new Date().getTime();
        res.data.list.map((item) => {
          if (item.create_time) {
            item.create_time = dateFormat(
              "YYYY-mm-dd",
              item.create_time * 1000
            );
          } else {
            item.create_time = "-";
          }
          if (item.allocate_time) {
            item.allocate_time = dateFormat(
              "YYYY-mm-dd",
              item.allocate_time * 1000
            );
          } else {
            item.allocate_time = "-";
          }
          if (item.follow_time) {
            item.follow_time = dateFormat(
              "YYYY-mm-dd",
              item.follow_time * 1000
            );
          } else {
            item.follow_time = "-";
          }
          if (item.acquisition_time) {
            item.acquisition_time = dateFormat(
              "YYYY-mm-dd",
              item.acquisition_time * 1000
            );
          } else {
            item.acquisition_time = "-";
          }
          item.format_last_follow_time = "-";
          item.format_next_follow_time = "-";
          if (item.follow_log) {
            item.format_last_follow_time =
              item.follow_log.follow_time === 0
                ? "-"
                : dateFormat(
                    "YYYY-mm-dd HH:MM",
                    item.follow_log.follow_time * 1000
                  );
            item.format_next_follow_time =
              item.follow_log.pre_follow_time === 0
                ? "-"
                : dateFormat(
                    "YYYY-mm-dd HH:MM",
                    item.follow_log.pre_follow_time * 1000
                  );
          }
          if (item.age === 0) {
            if (item.birthday !== 0) {
              const severalMonths = today - item.birthday * 1000;
              item.age = new Date(severalMonths).getMonth() + "个月";
            } else {
              item.age = "-";
            }
          } else {
            item.age = item.age + "岁";
          }
        });
        this.tableData = res.data.list;
        if (res.data.page > 1 && res.data.list.length === 0) {
          this.handleSearch();
        }
      });
    },
    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    },
    handlePay(row) {
      this.$confirm(
        "意向学员在完成缴费后，会自动转化为在读学员，同时跟进状态自动变为已成交，确定前往缴费？",
        `缴费 - ${row.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          this.savePageInfo();
          this.$router.push({
            name: "buyCourseConfirm",
            query: { id: String(row.id) },
          });
        })
        .catch(() => {});
    },
    handleFollow(id) {
      this.savePageInfo();
      this.$router.push({
        name: "studyDetails",
        query: { id: String(id), tab: "followup" },
      });
    },
    savePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "recruitLatentList",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "recruitLatentList",
        key: "page_size",
        value: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "recruitLatentList",
        key: "search_info",
        value: this.searchInfo,
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      // 后端反馈该排序字段更新为 follow_time
      if (e.prop === "format_last_follow_time") {
        this.searchInfo.sort_field = "follow_time";
      }
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
  },
  beforeDestroy() {
    eventBus.$off("latent-list-update-latent");
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.header-btns {
  position: relative;
  margin-bottom: 12px;
  .btn {
    margin-right: 20px;
    display: inline-block;
  }
}
.table-btns {
  .el-button {
    margin: 0 4px;
  }
}
.dot {
  &::after {
    content: "、";
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}
/deep/ .follow-content {
  .cell {
    width: 21em;
    overflow: hidden;
    text-overflow: ellipsis; //文本溢出显示省略号
    white-space: nowrap; //文本不会换行
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .cell {
        display: flex !important;
        align-items: center;
      }
      .caret-wrapper {
        position: relative;
        display: inline-block;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
.selfheader {
  display: flex;
  align-items: center;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.top-search-wrap {
  .mwow-form {
    margin-bottom: 16px;
  }
  .quick-wrap {
    .title {
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      color: #333;
      margin-right: 10px;
    }
    .mwow-button {
      margin-right: 10px;
      margin-bottom: 14px;
    }
  }
}
.allocate-wrap {
  display: flex;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  line-height: 30px;
  height: 30px !important;
  position: relative;
  .el-input {
    width: 165px;
  }
  /deep/.el-input__inner {
    border: none !important;
  }
  span {
    margin: 0 10px 0 0;
  }
  .el-input {
    width: auto;
    text-align: center;
  }
}
</style>
